var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import { USERDATA_FAILED, USERDATA_RECEIVED } from './userdata-action';
import { APP_RECEIVED } from "./apps-action";
import { APP_INFO_SET } from "./apps-action";
import { USER_LOGGED_OUT } from "./auths-action";

var initialState = {
    title: '',
    subtitle: 'Ikke innlogget',
    version: null,
    updatedAt: null,
    theme: {
        primaryColor: null,
        lightColor: null,
        darkColor: null
    },
    loaded: false,
    imageUrl: null
};

var appReducer = function appReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case APP_INFO_SET:
            return _extends({}, state, action.app);
        case USERDATA_RECEIVED:
            return _extends({}, state, {
                subtitle: action.userdata.name
            });
        case USERDATA_FAILED:
            return _extends({}, state, {
                subtitle: initialState.subtitle
            });
        case APP_RECEIVED:
            return _extends({}, state, {
                title: action.title,
                theme: action.theme,
                loaded: true,
                imageUrl: action.imageUrl
            });
        case USER_LOGGED_OUT:
            return _extends({}, initialState, {
                title: state.title,
                version: state.version,
                updatedAt: state.updatedAt,
                theme: state.theme,
                loaded: state.loaded
            });
        default:
            return state;
    }
};

export default appReducer;